export const searchRoute = () => '/booking/search'
